import { Box, Button, IconButton, Paper, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import {
  fallback,
  formatCategory,
  getInitials,
} from "../utils/formatters";
import { ReferralProgram } from "../types/view.referral";
import { EmailOutlined, PhoneOutlined, WhatsApp } from "@mui/icons-material";

interface Props {
  data: ReferralProgram;
}


export default function ReferralProfileCard({ data }: Props) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const fullName =
    `${fallback(data.name, "")} ${fallback(data.surname, "")}`.trim();

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "20px",
        p: 3,
        backgroundColor: colors.primary[900],
        height: "100%",
      }}
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            backgroundColor: "#A98776",
            color: "#fff",
            display: "grid",
            placeItems: "center",
            fontWeight: 700,
            fontSize: "1.5rem",
            mb: 2,
          }}
        >
          {getInitials(data.name, data.surname)}
        </Box>

        <Typography
          sx={{ fontSize: "1rem", fontWeight: 700, color: "#161616" }}
        >
          {fullName || "N/A"}
        </Typography>

        <Box
          sx={{
            mt: 1,
            px: 1.5,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: "#E7F1FF",
            color: "#4490FF",
            fontSize: "0.8rem",
          }}
        >
          {formatCategory(data.organisation_category)}
        </Box>

        <Typography sx={{ mt: 2, color: "#2B2B2B" }}>
          {fallback(data.consultant_name)}
        </Typography>
      </Box>

     <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
      <Button
        sx={{
          py: 1.5,
          px: 6,
          borderRadius: "8px",
          backgroundColor: "#7B5648",
          color: "#fff",
          textTransform: "none",
          fontWeight: 500,
          width: "80%",
          "&:hover": { backgroundColor: "#6A493D" },
        }}
      >
        Message
      </Button>
    </Box>

      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 2 }}>
        <IconButton
          sx={{
            backgroundColor: "#FEF0F0",
            "&:hover": { backgroundColor: "#FDDEDE" },
          }}
        >
          <EmailOutlined sx={{ color: "#E85C57", fontSize: 28 }} />
        </IconButton>

        <IconButton
          sx={{
            backgroundColor: "#F0FAF4",
            "&:hover": { backgroundColor: "#D8F3E3" },
          }}
        >
          <WhatsApp sx={{ color: "#25D366", fontSize: 28 }} />
        </IconButton>

        <IconButton
          sx={{
            backgroundColor: "#FDF4EE",
            "&:hover": { backgroundColor: "#FAE4D0" },
          }}
        >
          <PhoneOutlined sx={{ color: "#C47B4A", fontSize: 28 }} />
        </IconButton>
      </Box>
    </Paper>
  );
}
